import { ChangeDetectionStrategy, Component } from '@angular/core';
import { range } from 'lodash-es';

@Component({
  selector: 'app-timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineComponent {
  height = 540;
  width = 50;
  widthXs = 60;
  w1 = 5;
  w1Xs = 5;
  w2 = 10;
  w2Xs = 10;
  readonly timeline = range(0, 25);
  readonly hours = range(0, 5);
  readonly h = 24;

  calcTimePos(x: number): number {
    if (x === 0) {
      return 1;
    } else if (x === 24) {
      return this.height - 1;
    }

    return x * (this.height / this.h);
  }

  calcHourPos(i: number): number {
    const shift = i !== 4 ? (i ? 5 : 11) : 0;

    return (this.height / 4) * i + shift;
  }

  getHour(i: number): string {
    let hour;
    switch (i) {
      case 0:
        hour = '00:00';
        break;
      case 1:
        hour = '06:00';
        break;
      case 2:
        hour = '12:00';
        break;
      case 3:
        hour = '18:00';
        break;
      default:
        hour = '24:00';
        break;
    }

    return hour;
  }
}
